import React, { useEffect, useState } from "react";
import { HashRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import { auth } from "./firebase";
import { ref, get } from "firebase/database";
import { onAuthStateChanged } from "firebase/auth";
import Login from "./pages/Login";
import Main from "./pages/Main";
import Dashboard from "./pages/Dashboard";
import MapPage from './pages/MapPage';

import PetaEstate4 from "./pages/peta-estate-4/PetaEstate4";
import { MapDataProvider } from './pages/peta-estate-4/contexts/MapDataContext';

import ActivePlantation from "./pages/lokasi/ActivePlantation";
import ClosingPlantation from "./pages/lokasi/ClosingPlantation";

import MasterBudgetTanam from "./pages/labita/master-budget-tanam/MasterBudgetTanam";
import YTD from "./pages/labita/ytd/YTD";

import MonitorSetaraUreaPerUmur from "./pages/plantation/monitor-setara-urea-per-umur/MonitorSetaraUreaPerUmur";
import StandarPerUmur from "./pages/plantation/standar-per-umur/StandarPerUmur";

import MonitorRencanaBoom from "./pages/boom-sprayer/monitor-recana-boom/MonitorRencanaBoom";
import DataPJWilayah from "./pages/boom-sprayer/master-data/DataPJWilayah";

import MonitorHasilPanen from "./pages/harvesting/monitor-hasil-panen/MonitorHasilPanen";

import DailyProductionData from "./pages/prodactions/ph01/DailyProductionData";
import DailyProductionData02 from "./pages/prodactions/ph02/DailyProductionData02";
import MasterData from "./pages/prodactions/master-data/MasterData";
import TradeSectors from "./pages/prodactions/master-data/trade-sectors/TradeSectors";
import ClassificationCategories from "./pages/prodactions/master-data/classification-categories/ClassificationCategories";
import ProductSpecifications from "./pages/prodactions/master-data/product-specifications/ProductSpecifications";
import DistributionMapping from "./pages/prodactions/master-data/distribution-mapping/DistributionMapping";
import ProductionPlan from "./pages/prodactions/master-data/production-plan/ProductionPlan";

import LayoutBeratTanamanSAP from "./pages/pengamatan/berat-tanaman/LayoutBeratTanamanSAP";
import PersenBunga from "./pages/pengamatan/persen-bunga/PersenBunga";
import BuahAlami from "./pages/pengamatan/buah-alami/BuahAlami";
import BuahAlamiDetailPage from "./pages/pengamatan/buah-alami/BuahAlamiDetailPage";
import Destrak from "./pages/pengamatan/destrak-v1/Destrak";
import DestrakDetailPage from "./pages/pengamatan/destrak/DestrakDetailPage"

import MaterialCategory from "./pages/inventory/master-data/material-category/MaterialCategory";
import InventoryUoM from "./pages/inventory/master-data/uom/UoM";
import MaterialMaster from "./pages/inventory/master-data/material-master/MaterialMaster";
import MonitoringStokBahanPG4 from "./pages/inventory/forecast/MonitoringStokBahanPG4";
import RealisasiStokBahanPG4 from "./pages/inventory/realisasi/RealisasiStokBahanPG4";

import DroneBuahAlami from "./pages/drone/buah-alami/DroneBuahAlami";

import SensusPopulasiAnakanPisang from "./pages/pengamatan/sensus-populasi-anakan-pisang/SensusPopulasiAnakanPisang";
import WorkforceManagement from "./pages/dms/WorkforceManagement";
import DBMS from "./pages/dms/DBMS";
import FPMS from "./pages/dms/FPMS";
import Helper from "./pages/dms/Helper";
import GJMS from "./pages/dms/GJMS";
import SCM from "./pages/dms/SCM";
import OMS from "./pages/dms/OMS";
import MyProfile from "./pages/MyProfile";
import PengajuanBarang from "./pages/purchase-requisition/PengajuanBarang";
import HistoryPengajuanBarang from "./pages/purchase-requisition/history-pengajuan/HistoryPengajuan";
import SummaryPR from "./pages/purchase-requisition/summary-pr/SummaryPR";
import UoM from "./pages/ppic/UoM";
import Banana from "./pages/banana/Banana";

import Changelog from "./pages/about/changelog/Changelog";
import StokLahan from "./pages/labita/stok-lahan/StokLahan";

import {
  OverlayLazyLoadCircularProgressLabel,
  useLoadingManager,
  useCachedUserData
} from "./components/overlay-lazy-load-circular-progress-label";

import './App.css';

function App() {
  const [user, setUser] = useState(null);
  const [userFullData, setUserFullData] = useState(null);
  const [isAppReady, setIsAppReady] = useState(false);

  // Gunakan loading manager
  const {
    loadingState,
    startLoading,
    updateStep,
    updateProgress,
    completeLoading,
    setError
  } = useLoadingManager();

  const { getCachedData, setCachedDataForUser } = useCachedUserData();

  const fetchUserDataFromFirebase = async (firebaseUser, database) => {
    try {
      // Fetch user data dari database
      const userRef = ref(database, `db_user/tb_user/${firebaseUser.uid}`);
      const snapshot = await get(userRef);
      const userData = snapshot.val();
      
      if (!userData) {
        return {
          uid: firebaseUser.uid,
          email: firebaseUser.email,
          name: firebaseUser.displayName || firebaseUser.email.split('@')[0],
          avatar: firebaseUser.photoURL || `https://placehold.co/40x40/ADD8E6/000000?text=${(firebaseUser.email ? firebaseUser.email.charAt(0).toUpperCase() : 'U')}`,
          gender: null,
        };
      }

      // Fetch role jika ada id_role
      let roleName = null;
      if (userData.id_role) {
        const roleRef = ref(database, `db_config/db_wfms/tb_role/${userData.id_role}`);
        const roleSnapshot = await get(roleRef);
        const roleData = roleSnapshot.val();
        roleName = roleData?.nama_role || null;
      }

const completeUserData = {
    uid: firebaseUser.uid,
    email: userData.email || firebaseUser.email || "No email",
    name: userData.name || firebaseUser.displayName || firebaseUser.email.split("@")[0],
    avatar: userData.avatar || firebaseUser.photoURL || `https://placehold.co/40x40/ADD8E6/000000?text=${firebaseUser.email ? firebaseUser.email.charAt(0).toUpperCase() : "U"}`,
    id_role: userData.id_role,
    role: roleName ? roleName.toLowerCase() : null,
    gender: userData.gender || null,
    id_department: userData.id_department || "",
    id_jabatan: userData.id_jabatan || "",
    id_status_pekerjaan: userData.id_status_pekerjaan || "",
    id_status_tenaga_kerja: userData.id_status_tenaga_kerja || "",
    signatureBase64: userData.signatureBase64 || "",
    id_flow_order_default: userData.id_flow_order_default || "",
};

      // Simpan ke cache
      setCachedDataForUser(firebaseUser.uid, completeUserData);
      
      return completeUserData;
    } catch (error) {
      console.error("Error fetching user data:", error);
      throw error;
    }
  };

  useEffect(() => {
    let isMounted = true;

    // Import database secara dinamis
    import("./firebase").then(({ database }) => {
      const unsubscribe = onAuthStateChanged(auth, async (firebaseUser) => {
        if (!isMounted) return;

        if (firebaseUser) {
          // MULAI LOADING SEQUENCE
          if (isMounted) {
            startLoading([
              { step: 1, description: 'Checking authentication...' },
              { step: 2, description: 'Loading cached data...' },
              { step: 3, description: 'Fetching user data...' },
              { step: 4, description: 'Loading user role...' },
              { step: 5, description: 'Preparing application...' },
              { step: 6, description: 'Ready!' },
            ]);
          }

          try {
            // STEP 1: Authentication checked
            if (isMounted) {
              updateStep(1, 'Authentication verified');
              updateProgress(10, 'User authenticated');
            }

            // STEP 2: Check cache first
            if (isMounted) {
              updateStep(2, 'Checking cached data...');
            }
            const cachedData = getCachedData(firebaseUser.uid);
            
            if (cachedData) {
              if (isMounted) {
                updateProgress(30, 'Using cached data');
              }
              
              // Gunakan data cache sementara
              if (isMounted) {
                setUser(firebaseUser);
                setUserFullData(cachedData);
              }
              
              // Fetch fresh data di background
              setTimeout(async () => {
                if (!isMounted) return;
                try {
                  const freshData = await fetchUserDataFromFirebase(firebaseUser, database);
                  if (isMounted) {
                    setUserFullData(freshData);
                  }
                  console.log('Data updated in background');
                } catch (err) {
                  console.log('Background update failed, using cached data');
                }
              }, 100);
              
              if (isMounted) {
                updateStep(6, 'Loading from cache complete');
                updateProgress(100, 'Ready!');
                
                // Selesaikan loading dengan delay kecil
                setTimeout(() => {
                  if (isMounted) {
                    completeLoading();
                    setIsAppReady(true);
                  }
                }, 300);
              }
              
            } else {
              // STEP 3: No cache, fetch fresh data
              if (isMounted) {
                updateStep(3, 'Fetching user data from server...');
                updateProgress(40, 'Connecting to database');
              }
              
              const userData = await fetchUserDataFromFirebase(firebaseUser, database);
              
              if (isMounted) {
                updateStep(4, 'Loading user role...');
                updateProgress(70, 'Role loaded');
                
                updateStep(5, 'Preparing application...');
                updateProgress(90, 'Almost ready');
                
                setUser(firebaseUser);
                setUserFullData(userData);
                
                updateStep(6, 'Ready!');
                updateProgress(100, 'Application loaded successfully');
                
                // Selesaikan loading
                setTimeout(() => {
                  if (isMounted) {
                    completeLoading();
                    setIsAppReady(true);
                  }
                }, 500);
              }
            }
            
          } catch (error) {
            console.error("Error in loading sequence:", error);
            if (isMounted) {
              setError(`Failed to load: ${error.message}`);
              
              // Fallback: set basic user data
              setUser(firebaseUser);
              setUserFullData({
                uid: firebaseUser.uid,
                email: firebaseUser.email,
                name: firebaseUser.displayName || firebaseUser.email.split('@')[0],
                avatar: firebaseUser.photoURL || `https://placehold.co/40x40/ADD8E6/000000?text=${(firebaseUser.email ? firebaseUser.email.charAt(0).toUpperCase() : 'U')}`,
              });
              
              setTimeout(() => {
                if (isMounted) {
                  completeLoading();
                  setIsAppReady(true);
                }
              }, 2000);
            }
          }
          
        } else {
          // User not logged in
          if (isMounted) {
            setUser(null);
            setUserFullData(null);
            completeLoading();
            setIsAppReady(true);
          }
        }
      });

      return () => {
        isMounted = false;
        unsubscribe();
      };
    });

    return () => {
      isMounted = false;
    };
  }, []);

  // TAMPILKAN OVERLAY LOADING SELAMA LOADING
  if (loadingState.isOpen) {
    return (
      <OverlayLazyLoadCircularProgressLabel
        open={loadingState.isOpen}
        currentStep={loadingState.currentStep}
        progressValue={loadingState.progressValue}
        loadingSteps={loadingState.loadingSteps}
        additionalText={loadingState.additionalText}
        title="Loading PineTracker"
        subtitle="Please wait while we prepare your workspace"
        showSteps={true}
        showProgressBar={true}
        transparentBackground={true}
      />
    );
  }

  // JIKA BELUM READY, TAMPILKAN KOSONG
  if (!isAppReady) {
    return null;
  }

  // Setelah loading selesai, baru lakukan penentuan rute
  return (
    <>
    {/* Overlay Loading */}
      <OverlayLazyLoadCircularProgressLabel
      open={loadingState.isOpen}
      currentStep={loadingState.currentStep}
      progressValue={loadingState.progressValue}
      loadingSteps={loadingState.loadingSteps}
      additionalText={loadingState.additionalText}
      title="Loading PineTracker"
      subtitle="Please wait while we prepare your workspace"
      showSteps={true}
      showProgressBar={true}
      transparentBackground={true}
    />

    <Router>
      <Routes>
        {/* Jika user sudah login, redirect dari /login ke halaman utama (misal /dashboard) */}
        <Route 
          path="/login" 
          element={
            user ? (
              // Jika sudah login, redirect ke dashboard
              <Navigate to="/dashboard" replace />
            ) : (
              // Jika belum login, tampilkan login page
              <Login />
            )
          } 
        />
        
        {/* Jika user belum login, redirect ke /login untuk semua rute yang diproteksi di bawah Layout */}
        <Route
          path="/"
          element={
            user ? (
              <Main 
                user={user} 
                userData={userFullData}
                initialUserRole={userFullData?.role}
              />
            ) : (
              // Jika belum login, redirect ke login
              <Navigate to="/login" replace />
            )
          }
        >
          {/* children will render inside <Outlet /> in Layout.jsx 
          <Route index element={<Dashboard />} /> */}

          <Route path="dashboard" element={<Dashboard />} />
          <Route index element={<Navigate to="/dashboard" replace />} />
          
          <Route path="map" element={<MapPage />} />
          <Route path="peta-estate4" element={<MapDataProvider><PetaEstate4 /></MapDataProvider>} />

          {/* Lokasi Routes */}
          <Route path="lokasi">
            <Route path="active-plantation" element={<ActivePlantation />} />
            <Route path="closing-plantation" element={<ClosingPlantation/>} />
          </Route>

          {/* Labita Routes */}
          <Route path="labita">
            <Route path="stok-lahan" element={<StokLahan/>}/>
            <Route path="master-budget-tanam" element={<MasterBudgetTanam />} />
            <Route path="ytd" element={<YTD />} />
          </Route>

          {/* Plantation Routes */}
          <Route path="plantation">
            <Route path="monitor-setara-urea-per-umur" element={<MonitorSetaraUreaPerUmur />} />
            <Route path="standar-per-umur" element={<StandarPerUmur />} />
          </Route>

          {/* Boom Spray Routes */}
          <Route path="boom-sprayer">
            <Route path="monitor-recana-boom" element={<MonitorRencanaBoom />} />
            <Route path="master-data" element={<DataPJWilayah />} />
          </Route>

          <Route path="harvesting">
            <Route path="monitor-hasil-panen" element={<MonitorHasilPanen/>}/>
          </Route>

          <Route path="prodactions">
            <Route path="ph01" element={<DailyProductionData/>}/>
            <Route path="ph02" element={<DailyProductionData02/>}/>
            <Route path="master-data" element={<MasterData/>}/>
            <Route path="master-data/trade-sectors" element={<TradeSectors/>}/> 
            <Route path="master-data/classification-categories" element={<ClassificationCategories/>}/> 
            <Route path="master-data/product-specifications" element={<ProductSpecifications/>}/> 
            <Route path="master-data/distribution-mapping" element={<DistributionMapping/>}/> 
            <Route path="master-data/production-plan" element={<ProductionPlan/>}/>
          </Route>

          <Route path="inventory">
            <Route path="material-category" element={<MaterialCategory/>}/>
            <Route path="uom" element={<InventoryUoM/>}/>
            <Route path="material-master" element={<MaterialMaster/>}/>
            <Route path="forecast" element={<MonitoringStokBahanPG4/>}/>
            <Route path="realisasi" element={<RealisasiStokBahanPG4/>}/>
          </Route>

          <Route path="drone">
            <Route path="buah-alami" element={<DroneBuahAlami/>}/>
          </Route>

          {/* Pengamatan Routes */}
          <Route path="pengamatan">
            <Route element={<Dashboard />} />
            <Route path="berat-tanaman" element={<LayoutBeratTanamanSAP />} />
            <Route path="persen-bunga" element={<PersenBunga />} />
            <Route path="buah-alami" element={<BuahAlami />} />
            
            <Route path="buah-alami/detail/:pengamatanKey" element={<BuahAlamiDetailPage />} />

            <Route path="destrak-v1" element={<Destrak />} />
            {/*<Route path="destrak/detail/:pengamatanKey" element={<DestrakDetailPage/>}/>*/}

            <Route path="sensus-populasi-anakan-pisang" element={<SensusPopulasiAnakanPisang />} />
          </Route>
          
          {/* DMS Routes */}
          <Route path="dms">
            <Route path="workforce-management" element={<WorkforceManagement />} />
            <Route path="database-management-system" element={<DBMS />} />
            <Route path="fresh-pineapple-management-system" element={<FPMS />} />
            <Route path="helper" element={<Helper />} />
            <Route path="geojson-management-system" element={<GJMS />} />
            <Route path="supply-chain-management" element={<SCM />} />
            <Route path="observation-management-system" element={<OMS />} />
          </Route>

          <Route path="banana" element={<Banana />} />

          <Route path="purchase-requisition">
            <Route path="pengajuan-barang-expand" element={<PengajuanBarang />} />
            <Route path="history-pengajuan/history-pengajuan-barang-expand" element={<HistoryPengajuanBarang />} />
            <Route 
              path="summary-pr" 
              element={
                user ? (
                  <SummaryPR />
                ) : (
                  <Navigate to="/login" replace />
                )
              } 
            />
          </Route>

          {/* PPIC Routes */}
          <Route path="ppic">
            <Route path="dashboard" element={<div>PPIC Dashboard Page</div>} />
            <Route path="order" element={<div>PPIC Order Page</div>} />
            <Route path="katalog" element={<div>PPIC Katalog Page</div>} />
            <Route path="transaksi" element={<div>PPIC Transaksi Page</div>} />
            <Route path="cost-center" element={<div>PPIC Cost Center Page</div>} />
            <Route path="uom" element={<UoM />} />
            <Route path="kategori" element={<div>PPIC Kategori Page</div>} />
            <Route path="berita-acara" element={<div>PPIC Berita Acara Page</div>} />
          </Route>

          <Route path="about">
            <Route path="changelog" element={<Changelog />} />
          </Route>

          <Route path="my-profile/*" element={<MyProfile />} />

          {/* Optional: Tambahkan rute catch-all untuk halaman 404 atau redirect ke dashboard */}
          <Route path="*" element={<Navigate to="/" replace />} /> 
        </Route>
      </Routes>
    </Router>
    </>
  );
}

export default App;